var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58625 23.9999H2C1.73478 23.9999 1.48043 23.8946 1.29289 23.707C1.10536 23.5195 1 23.2651 1 22.9999V17.4137C1.00012 17.1488 1.10532 16.8948 1.2925 16.7074L16.7075 1.29242C16.895 1.10502 17.1493 0.999756 17.4144 0.999756C17.6795 0.999756 17.9337 1.10502 18.1213 1.29242L23.7075 6.87492C23.8949 7.06243 24.0002 7.31669 24.0002 7.58179C24.0002 7.84689 23.8949 8.10115 23.7075 8.28867L8.2925 23.7074C8.10511 23.8946 7.85111 23.9998 7.58625 23.9999Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEdit);
export default __webpack_public_path__ + "static/media/userEdit.5da9d885f81d1a95ceaf2f851529d28f.svg";
export { ForwardRef as ReactComponent };